// import React, { useEffect, useRef, useState } from 'react'
// import { CheckSquare, Pencil, PlusCircle, Square } from 'react-bootstrap-icons'
// import Questionnaire from '../../../../../libs/api/services/Questionnaire'
// import QBuilderGenerics from '../QBuilderGenerics'
// import QBuilderComponentOptions from './QBuilderComponentOptions'
// import QBuilderComponentSingleSelctItem from './widgets/QBuilderComponentSingleSelctItem'
import React, { useContext, useEffect, useState } from 'react';
import { CheckSquare, Pencil, PlusCircle, Square } from 'react-bootstrap-icons';
import QuestionnaireBuilderContext from '../QuestionnaireBuilderProvider';
import QBuilderComponentOptions from './QBuilderComponentOptions';
import './QEditor.scss';
import QBuilderComponentSingleSelctItem from './widgets/QBuilderComponentSingleSelctItem';
import LabelsOptions from './widgets/components/LabelsOptions';
export default function QBuilderComponentMultiSelect({
    Component,
    accessTypes,
    onAction,
    idx,
    edit,
    defaultMode,
    SectionComponents,
    values,
}) {
    const { SetComponentValue, GetComponentValues, SetResponse, ComponentAnswers } = useContext(QuestionnaireBuilderContext)
    const [mode, setMode] = useState(edit ? '' : '')
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(true)
    // alert(mode)
    useEffect(() => {
        if (GetComponentValues(Component.id)["Options"]) {
            var options = JSON.parse(GetComponentValues(Component.id)["Options"])
            if (ComponentAnswers[Component.id]) {
                const _opts = JSON.parse(ComponentAnswers[Component.id])
                for (let i = 0; i < _opts.length; i++) {
                    var opt = options.find(a => a.option === _opts[i].option)
                    opt.active = _opts[i].active
                }
            }
            setOptions(options)
        }
        // Maybe check if need to lookup from API
        setLoading(false)
    }, [])

    const _setProperty = (prop, value) => {
        SetComponentValue(Component, prop, value)
            .then(() => {
                // setDetails({ ...details, [prop]: value })
            })
    }

    useEffect(() => {
        if (defaultMode && defaultMode === 'Overview')
            setMode('')
    }, [defaultMode])

    const _handleOptionSelected = (i) => {
        var _options = options
        if (_options[i].active)
            _options[i].active = false
        else
            _options[i].active = true
        setOptions([..._options])
        SetResponse(Component, JSON.stringify(_options), true)
        // _handleSetValue(_options)
    }

    if (loading) return <div>Loading</div>

    return <CommonLayoutWrapper
        OnEdit={() => setMode('Edit Text')}
        edit={edit}
        mode={mode}
        accessTypes={accessTypes}
        AdminMode={
            <AdminLayoutWrapper
                Component={Component}
                mode={mode}
                setMode={setMode}
                Tabs={{
                    "Edit Text": {
                        mode: "Field Name",
                        component: <AdminEditText _setProperty={_setProperty} Component={Component} />
                    },
                    "Options": {
                        mode: "Field Options",
                        component: <AdminOptions options={options} setOptions={setOptions} _setProperty={_setProperty} SectionComponents={SectionComponents} values={values} />
                    },
                    "Link": {
                        mode: "Link Field",
                        component: <AdminLink />
                    },
                    // "Style":{
                    //     mode: "Field Name",
                    //     component: <AdminEditText _setProperty={_setProperty} Component={Component} />
                    // },
                }}
            />
            // <AdminMode
            //     mode={mode}
            //     setMode={setMode}
            //     _setProperty={_setProperty}
            //     setOptions={setOptions} options={options}
            //     SectionComponents={SectionComponents}
            //     values={values}
            //     Component={Component}
            // />

        }
        NormalMode={<>
            <div className='d-flex justify-content-between'>
                <label>{GetComponentValues(Component.id)["Question"]}<b className='text-secondary'><small>{GetComponentValues(Component.id)["Required"] && JSON.parse(GetComponentValues(Component.id)["Required"]) ? "*" : ''}</small></b></label>
            </div>
            <div>
                {
                    options.map((o, i) =>
                        // view && view === 'Discover'
                        accessTypes.includes('Edit')
                            ?
                            <div
                                key={Math.floor(Math.random() * 100000)}
                                style={{ cursor: 'pointer' }}
                                onClick={(e) => _handleOptionSelected(i)}
                                className='active m-2'>
                                {
                                    o.active
                                        ?
                                        <CheckSquare className='me-2' />
                                        :
                                        <Square className='me-2' />
                                }
                                {o.option}
                            </div>
                            :
                            <div
                                key={Math.floor(Math.random() * 100000)}
                                className='active m-2'>
                                {
                                    o.active
                                        ?
                                        <div>
                                            <CheckSquare className='me-2' />
                                            {o.option}
                                        </div>
                                        :
                                        <div className=' opacity-25'>
                                            <Square className='me-2' />
                                            {o.option}
                                        </div>
                                }
                            </div>

                    )
                }
            </div></>}
    />
}

export const CommonLayoutWrapper = ({ mode, AdminMode, NormalMode, edit, OnEdit, accessTypes }) => {
    if (!accessTypes) return <></>
    return (
        <>
            {mode !== '' && AdminMode}
            <div className={'text-start '.concat(mode !== '' ? 'bg-primary-container opacity-75 shadow' : '')}>
                <EditPencilWrapper isEdit={edit} onClick={OnEdit} />
                {NormalMode}
            </div>
        </>
    )
}

export const EditPencilWrapper = ({ isEdit, onClick }) => isEdit && <Pencil className='me-2' onClick={(e) => onClick()} />

export const AdminLayoutWrapper = ({ Component, mode, setMode, Tabs }) =>
    <div style={{
        cursor: 'pointer',
        // zIndex: 999,
        // right: '0px',
        // top: '50px',
        // bottom: '50px',
        // animation: 'fadeIn 0.35s linear 1 forwards'
    }} className={'bg-light w-50 shadow rounded text-start p-2 position-fixed '.concat(' slide-in')}>
        <QBuilderComponentOptions Component={Component} onClose={() => setMode('')} />
        <div className='d-flex rounded bg-primary-container m-2'>
            {Object.keys(Tabs).map(tab => <div key={tab} className={`p-2 ${mode === tab ? 'active' : ''}`} onClick={() => setMode(tab)}>{Tabs[tab].mode}</div>)}
        </div>
        {Object.keys(Tabs).includes(mode) && Tabs[mode].component}
    </div>

export const AdminEditText = ({ Component }) => {
    const { GetComponentValues, SetComponentValue } = useContext(QuestionnaireBuilderContext)
    const _handleSetFieldName = (t) =>
        SetComponentValue(Component, "Question", t)

    const _handleSetRequired = () => {
        SetComponentValue(Component, "Required",
            GetComponentValues(Component.id)["Required"] ?
                JSON.stringify(!JSON.parse(GetComponentValues(Component.id)["Required"]))
                : "true"
        )
    }

    return (
        <div style={{ cursor: 'pointer' }} className='bg-light rounded text-start p-2 opacity-75'>
            <div className='text-center'>
                <div className='d-flex justify-content-between'>
                    <b>Enter a name for the field</b>
                </div>
                <input
                    onChange={(e) => _handleSetFieldName(e.target.value)}
                    defaultValue={GetComponentValues(Component.id)["Question"]}
                    className='form-control form-control-sm' placeholder='Field Name' />
                <div className='d-flex justify-content-between'>
                    <div>
                        <div>
                            <b>Is this field required?</b>
                        </div>
                        <div onClick={(e) => _handleSetRequired()}>
                            {GetComponentValues(Component.id)["Required"] && JSON.parse(GetComponentValues(Component.id)["Required"]) ? <CheckSquare size={20} className='me-1' /> : <Square size={20} className='me-1' />}
                            Field is required
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const AdminLink = () => {
    return (
        <div>
            <p className='text-center'>To link this field to an existing patient profile field select the category and field below</p>
        </div>
    )
}

export const AdminOptions = ({ options, setOptions, _setProperty, SectionComponents, values }) => {
    const [option, setOption] = useState({ option: '' })
    const _hadleAddOption = (_option) => {
        const _options = [...options, _option]
        setOptions(_options)
        _setProperty('Options', JSON.stringify(_options))
        setOption({ option: '' })
    }
    const _handleRemoveOption = (i) => {
        var _options = options
        _options.splice(i, 1)
        setOptions([..._options])
        _setProperty('Options', JSON.stringify(_options))
    }
    const _handleEditOption = (i, v) => {
        var _options = options
        options[i] = v
        setOptions([..._options])
        _setProperty('Options', JSON.stringify(_options))
    }
    return (
        <div>
            <div className='d-flex flex-column align-items-stretch'>
                <div className='flex-grow-1'>
                    <b>Answer</b>
                    <input
                        value={option.option ? option.option : ''}
                        onChange={(e) => setOption({ ...option, option: e.target.value })}
                        className='form-control form-control-sm' placeholder='Answer' />
                </div>
                <div className='flex-grow-1 p-2'>
                    <div className='row'>
                        <div className='col-4 text-center'>
                            <b>Answer Weight</b>
                            <input
                                value={option.option ? option.weight : ''}
                                onChange={(e) => setOption({ ...option, weight: e.target.value })}
                                type='number'
                                className='form-control form-control-sm' placeholder='Answer Weight' />
                        </div>
                        <div
                            onClick={(e) => setOption({ ...option, trigger: !option.trigger })}
                            className='col-4 text-center'>
                            <b>Trigger Alert</b>
                            <div>
                                {
                                    option.trigger
                                        ?
                                        <CheckSquare size={20} className='me-1' />
                                        :
                                        <Square size={20} className='me-1' />
                                }
                                Alert if option selected
                            </div>
                        </div>
                        <div
                            className='col-4 text-center'>
                            <LabelsOptions
                                defaultLabels={option.Labels}
                                onChange={(l) => setOption({ ...option, Labels: l })}
                            />
                        </div>
                    </div>
                    <div className='text-center'>
                        <button
                            onClick={(e) => _hadleAddOption(option)}
                            className='btn-xs'>
                            <PlusCircle />
                            Add
                        </button>
                    </div>
                </div>
            </div>
            {
                options.map((o, i) =>
                    <QBuilderComponentSingleSelctItem
                        o={o}
                        SectionComponents={SectionComponents}
                        onRemove={() => _handleRemoveOption(i)}
                        onEdit={(v) => _handleEditOption(i, v)}
                        values={values}
                    />
                )
            }
        </div>
    )
}